import React from 'react'
import { render } from 'react-dom'
import GoogleAnalytics from 'react-ga'
import App from './App'
import * as serviceWorker from './serviceWorker'

GoogleAnalytics.initialize(process.env.REACT_APP_GA_KEY)

render(<App />, document.getElementById('root'))

serviceWorker.register()
